import script from "./MobileReceivedReportReplyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileReceivedReportReplyModal.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/mobile/ticket.css?vue&type=style&index=0&id=5646533b&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5646533b"]])

export default __exports__